/**
 * Projects Module Configuration
 *
 * Manages discrete bodies of work (inspections, progress, warranty)
 * at properties. Supports CompanyCam integration for photo/document sync.
 *
 * @see .context/WEB-APP.md for architecture documentation
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const projectsModule: AppModule = {
    id: 'projects',

    navigation: {
        label: 'Projects',
        icon: 'clipboard-list',
        path: '/projects',
        order: 15,
        moduleKey: 'projects',


        pages: [
            {
                label: 'All Projects',
                path: '/projects',
            },
            {
                label: 'Add Project',
                path: '/projects/create',
            },
        ],
    },

    routes,
}

export default projectsModule
